import { useState, useEffect } from 'react';

type Theme = 'light' | 'dark';

export const useDarkMode = () => {
  const [theme, setTheme] = useState<Theme>(() => {
    const saved = localStorage.getItem('theme') as Theme;
    return saved || 'light';
  });

  const [isDark, setIsDark] = useState(() => {
    return theme === 'dark';
  });

  useEffect(() => {
    const root = window.document.documentElement;

    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [isDark]);

  useEffect(() => {
    localStorage.setItem('theme', theme);
    setIsDark(theme === 'dark');
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => {
      return prev === 'light' ? 'dark' : 'light';
    });
  };

  const setLightTheme = () => setTheme('light');
  const setDarkTheme = () => setTheme('dark');

  return {
    theme,
    isDark,
    toggleTheme,
    setLightTheme,
    setDarkTheme,
  };
};
